import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const apiCall = async (endpoint, method = "get", options = {}) => {
  try {
    // console.log("options: ", options);
    const token = getAuthToken();

    if (!token) {
      throw new Error("Authentication token not found");
    }

    const config = {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await api[method](endpoint, config);
    return response.data;
  } catch (error) {
    console.error(
      `API call failed: ${method.toUpperCase()} ${endpoint}`,
      error
    );

    throw new Error(
      error.response?.data?.message ||
        error.message ||
        "An error occurred during the API call"
    );
  }
};

const createContact = async (contactData = {}) => {
  // console.log("contact data: ", contactData);
  const formData = new FormData();
  formData.append("title", contactData.title);
  formData.append("link", contactData.link);
  formData.append("type", contactData.type);
  formData.append("iconSource", contactData.iconSource);
  if (contactData.iconSource === "custom") {
    formData.append("image", contactData.image);
  }
  try {
    const token = getAuthToken();
    const data = await api.post("/contacts", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
  // return apiCall("/contact", "post", { data: contactData });
};

// const getContacts = async () => {
//   return apiCall("/contact", "get");
// };

const getContact = async (id) => {
  if (!id) {
    throw new Error("Contact ID is required");
  }
  return apiCall(`/contact/${id}`, "get");
};

// const updateContact = async (id, updateData = {}) => {
//   if (!id) {
//     throw new Error("Contact ID is required");
//   }
//   return apiCall(`/contact/${id}`, "put", { data: updateData });
// };

const deleteContact = async (id) => {
  if (!id) {
    throw new Error("Contact ID is required");
  }
  return apiCall(`/contact/${id}`, "delete");
};

async function getContacts() {
  try {
    const token = getAuthToken();
    if (!token) throw new Error("Unauthorized: No token found");
    const response = await api.get("/contacts", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function updateContact(contactId, contactData) {
  try {
    if (!contactData) throw new Error("Please provide contact data");
    const token = getAuthToken();
    const formData = new FormData();
    formData.append("title", contactData.title);
    formData.append("link", contactData.link);
    formData.append("type", contactData.type);
    formData.append("image", contactData.image);
    formData.append("iconSource", contactData.iconSource);
    if (!token) throw new Error("Unauthorized: No token found");
    const response = await api.put(`/contacts/${contactId}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { createContact, getContacts, updateContact, deleteContact };
